import React from 'react';

/**
 * Skeleton Card con ESATTAMENTE le stesse dimensioni del Card component
 * Previene layout shift durante il caricamento dei dati
 */
const SkeletonCard: React.FC = () => {
  return (
    <div 
      className="bg-white rounded-xl overflow-hidden shadow-md"
      style={{ 
        minHeight: '480px',
        height: '480px',
        contain: 'layout'
      }}
      aria-busy="true"
      aria-label="Caricamento annuncio..."
    >
      {/* Image placeholder - 320px esatti come Card reale */}
      <div 
        className="relative bg-gray-200"
        style={{ height: '320px', overflow: 'hidden' }}
      >
        {/* Shimmer effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-shimmer bg-[length:200%_100%]" />
        
        {/* Badge placeholder top-right */}
        <div 
          className="absolute top-3 right-3 bg-gray-300 rounded-full"
          style={{ width: '60px', height: '24px' }}
        />
        
        {/* Badge placeholder bottom-left */}
        <div 
          className="absolute bottom-3 left-3 bg-gray-300 rounded-full"
          style={{ width: '100px', height: '24px' }}
        />
      </div>
      
      {/* Content placeholder - 160px per matchare Card desktop */}
      <div className="p-4" style={{ minHeight: '160px' }}>
        {/* Title placeholder */}
        <div 
          className="h-7 bg-gray-200 rounded animate-pulse mb-2"
          style={{ minHeight: '28px', width: '70%' }}
        />
        
        {/* Location placeholder */}
        <div className="flex items-center justify-between mb-2" style={{ minHeight: '32px' }}>
          <div className="flex items-center gap-2 flex-1">
            <div className="w-4 h-4 bg-gray-300 rounded-full" />
            <div className="h-4 bg-gray-200 rounded animate-pulse" style={{ width: '60%' }} />
          </div>
          
          {/* Category badge placeholder */}
          <div 
            className="bg-gray-200 rounded-full animate-pulse"
            style={{ width: '80px', height: '24px' }}
          />
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;
